import { render, staticRenderFns } from "./LineupPlayers.vue?vue&type=template&id=1b3d0476&"
import script from "./LineupPlayers.vue?vue&type=script&lang=js&"
export * from "./LineupPlayers.vue?vue&type=script&lang=js&"
import style0 from "./LineupPlayers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports